import React, { useState, useEffect, useRef } from "react";
import { Modal, Row, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import moment from "moment/moment";
import { useSelector } from "react-redux";
import APICom from "../../../utils/helpers/APICom";
import TimePicker from "rc-time-picker";
import GridControl from "../../Controls/gridControl";
import { ValidateModule } from "tabulator-tables";
import Timer from "../../Controls/Timer";
import { mainstore } from "../../../store";
import PersistStorage from "../../../utils/helpers/PersistStorage";
import ConfirmationModal from '../../../components/Controls/ConfirmationModal.js';



function ForceSchedulingComponent(props) {

  const { loginData } = useSelector((store) => store.login);
  const [loading, setLoading] = useState(false);
  const [ForceStopViewData, setForceStopViewData] = useState(props.stopViewGridData);
  const [isActive, setIsActive] = useState(true);
  const duration = parseInt(mainstore.getState().configuration.ManifestForceAssignRejectLoaderTime); // Set the duration of the timer in seconds
  const violationstring = props.forceData?.violation_string.replace(new RegExp('\r?\n', 'g'), ' ').replace(new RegExp('<b>', 'g'), '').replace(new RegExp('</b>', 'g'), '') || '';
  const iRUnID = props.forceData?.run_id || '';
  let ManifestNumber = PersistStorage.retrieve("ManifestNumber", false);
  const ForceSchedulingTableObject = useRef(null);
  const [rowMoveFlag, setRowMoveFlag] = useState(false);
  const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Force Scheduling',
    body:'An error occured while saving', btnCancelText: 'No', btnOkText: 'Yes'});

  const handleCloseForceScheduling = () => {
    if (props.showForceSchedulingComponent) {
      props.setshowForceSchedulingComponent(false);
    }
  }


  const handleAcceptChanges = async () => {
    setLoading(true);
    if (isActive)
      setIsActive(false); // Only set to false if it's currently true

    let params = {
      "run_id": parseInt(iRUnID),
      "route_no": "",
      "user_id": loginData.iUserID,
      "app_id": 26,
      "manifestNumber": ManifestNumber,
      "is_route_suggestion": true

    }
    let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/AcceptSuggestedRoute", "post", { "Content-Type": "application/json" }, params, null);
    if(response !== null && response.data !== null && response.data.msg !== null && response.data.msg !== ''){
      setLoading(false);
      setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Force Scheduling', body:response.data.msg, btnOkText: 'Ok'}));
      
    }

    else{
      handleCloseForceScheduling();

    }
    
  }

  const handleRejectChanges = async () => {
    if (isActive)
      setIsActive(false); // Only set to false if it's currently true

    let params = {
      "run_id": parseInt(iRUnID)
    }

    let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/RejectSuggestedRoute", "post", { "Content-Type": "application/json" }, params, null);
    if(response !== null && response.data !== null && response.data.msg !== null && response.data.msg !== ''){
      setConfirmationModalObj((prevState) => ({...prevState, show:true, title:'Force Scheduling', body:'An Error Occured while Rejecting', btnOkText: 'Ok'}));
      
    }

    else{
      handleCloseForceScheduling();

    }
    
  }


  const [ForceStopViewGridOptions, setForceStopViewGridOptions] = useState({
    height: 300,
    heightoffset: 600,
    calculateHeight: false,
    pagination: false,
    paginationMode: "local",
    paginationSize: 100,
    paginationSizeSelector: [100, 200, 300, 400, 500],
    selectable: true,
    reactiveData: false, //enable data reactivity
    layout: "fitDataStretch",
    placeholder: "No Data Available",
    clipboard: false,
    selectableRangeMode: "click",
    GridName: "ForceStopViewGrid",
    paginationCounter: "rows",
    intervalEnable: false,
    movableColumns: true,
    movableRows: false,
    vDefaultGridName: "ForceStopViewGrid",
    index: "Index",
    autoColumns: true,
    sortCondition: true,
    bSysUser: 1,
    intervalEnable: false,
    persistence: false,
    bWebApplySettingToAll: true,
    GridReturnOnlyIDColumnInRowData: false,
    AlwaysHiddenColumns: ["Latitude", "Longitude", "Select", "Index", "nTotalPassengerCount", "nTotalWCCount"],
    containerClass: "col position-relative mt-2",
    Containerstyle: {},
    customWidthCols: ["Address-560"],
    footerElement: '',
    ActionList: false,
    ActionRowColoring: true,
    ArrangeClusterTripsErrorCases: [{"TripAtTop":"Trip is already at the top.", "TripAtBottom":"Trip is already at the bottom.", 
      "PUAfterDO": "Pickup can't come after its Dropoff!", "DOBeforePU":"Dropoff can't come before its Pickup!",
      "PrevRowNotExist":"Action not allowed because no previous row exist", "PrevDepotTrip":"Action not allowed because previous trip is depot trip",
      "PrevWillCallTrip":"Action not allowed because previous trip is a will call trip", "PerformedStops":"Action not allowed because trip has already been performed",
      "PrevPerformedStop":"Action not allowed because previous trip has already been performed",
      "PrevBreakTrip":"Action not allowed because previous trip is a break trip", "NextDepotTrip":"Action not allowed because next trip is depot trip",
      "NextvWillCallTrip":"Action not allowed because next trip is a will call trip","NextBreakTrip":"Action not allowed because next trip is a break trip",
      "NextPerformedStop":"Action not allowed because next trip has already been performed",
      "CompletedTrip":"Action not allowed because dragged trip has already been performed"
      }],
    tableDoubleClickFunc: function (table, row) {
    },
    footerElementHandles: function (table) {
      ForceSchedulingTableObject.current = table;

      let allRecords = ForceSchedulingTableObject.current.getData()


      if(allRecords !== null){

        for(var k = 0; k < allRecords.length; k++)
          {
            if (allRecords[k]["PUPerson"]?.toLowerCase() === "breaktrip")
            {
              let break_trip_key = allRecords[k]["Conf Number"]
              var JobID = ServiceStop(break_trip_key, table);
              var selectedRowData = table.getRow(JobID).getData();
              var Address = selectedRowData.Address;
              var Latitude = selectedRowData.Latitude;
              var Longitude = selectedRowData.Longitude;
              table.updateData([{ Index: allRecords[k].Index, Address: Address}]);
              table.updateData([{ Index: allRecords[k].Index, Latitude: Latitude}]);
              table.updateData([{ Index: allRecords[k].Index, Longitude: Longitude}]);

            }
          }
      }
     },
    rowSelectionChangeHandle: function (data) {

    },
  });

  function ServiceStop(conf, tableData) {
    var result = tableData.getData()
    let i = result.findIndex((trip) => trip["Conf Number"] === conf);
    let j = i;
    let serviceTrip = -1;
    let bServiceTripFound = false;
  
    while (i >= 0) {
      const _StopType = result[i]["Type"];
      const _PUPerson = result[i]["PUPerson"];
  
      if (
        (_StopType.toLowerCase() === 'pu' || _StopType.toLowerCase() === 'do') &&
        _PUPerson.toLowerCase() !== 'breaktrip' &&
        _StopType.toLowerCase() !== 'idletime' &&
        _StopType.toLowerCase() !== 'startdept'
      ) {
        serviceTrip = result[i]["Index"];
        bServiceTripFound = true;
        break;
      }
      i--;
    }
  
    if (!bServiceTripFound) {
      while (j < result.length) {
        const _StopType = result[j]["Type"];
        const _PUPerson = result[j]["PUPerson"];
  
        if (
          (_StopType.toLowerCase() === 'pu' || _StopType.toLowerCase() === 'do') &&
          _PUPerson.toLowerCase() !== 'breaktrip' &&
          (_StopType.toLowerCase() !== 'idletime' || _StopType.toLowerCase() !== 'enddept')
        ) {
          serviceTrip = result[j]["Index"];
          bServiceTripFound = true;
          break;
        }
        j++;
      }
    }
  
    return serviceTrip;
  }

  const handleConfirmationModalOk = () =>{
    setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    handleCloseForceScheduling();
  }

  const handleConfirmationModalClose = () =>{
    setConfirmationModalObj((prevState) => ({...prevState, show:false}));
}


  return (
    <>
      <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
                onOk={handleConfirmationModalOk}  btnOkText={confirmationModalObj.btnOkText} onClose={handleConfirmationModalClose}  ShowCancelButton="false" />
      <Modal show={props.showForceSchedulingComponent ? 1 : 0} centered onHide={handleRejectChanges} backdrop="static" keyboard={true} size="lg" animation={true}
        aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-tripDetails-width">
        <Modal.Header className='activate_dialog_header_bgcolor tripDetails-DialogHeader user-select-none' closeButton>
          <Modal.Title>Force Route Scheduling</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ width: '82%', float: 'left' }} className="m-0 user-select-none fw-bold">{violationstring}</p>
          <p style={{ width: '11%', float: 'left', paddingTop: '16px' }} className="m-0 user-select-none fw-bold">Auto Rejection in </p>
          <Timer isActive={isActive} duration={duration} onExpire={handleRejectChanges}></Timer>
        </Modal.Body>

        <Row className="mt-1 m-0">
          <GridControl Data={ForceStopViewData} options={ForceStopViewGridOptions} setRowMoveFlag = {setRowMoveFlag}/>
        </Row>


        <Modal.Footer>
          <Button className="activate_btn_ok border-0" onClick={handleAcceptChanges} disabled={loading}>Accept</Button>
          <Button className="activate_btn_ok border-0" onClick={handleRejectChanges} disabled={loading}>Reject</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ForceSchedulingComponent;